// OSS 上 preset 文件的存储路径前缀（相对 storage 根 + prefix）：
export const buildOssPresetPath = (): string => `/presets`
